"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _Header = require("./Header");

var _storage = require("../../../../utils/storage");

const storageConfig = {
  key: 'ViewActionAccordionState',
  useLocalStorage: true
};

function getAccordionState(id) {
  return (0, _storage.getPersisted)({ ...storageConfig,
    prop: id
  }, 'closed');
}

function setAccordionState(id) {
  return status => {
    if (status === 'open') {
      (0, _storage.setPersisted)({ ...storageConfig,
        prop: id
      }, 'open');
    }

    if (status === 'closed') {
      (0, _storage.setPersisted)({ ...storageConfig,
        prop: id
      }, 'closed');
    }
  };
}

const Drawer = _styledComponents.default.div`
  padding: 0 ${_blocks.spacing.loose} ${_blocks.spacing.loose};
`;
const Section = _styledComponents.default.div`
  border-bottom: 1px solid ${_blocks.palette.neutral3};
`;

const Accordion = ({
  label,
  initialState,
  persistId,
  children
}) => {
  const persistedState = persistId !== undefined ? getAccordionState(persistId) : 'closed';
  return /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(_blocks.Accordion, {
    onChange: persistId !== undefined ? setAccordionState(persistId) : undefined,
    initialState: initialState || persistedState,
    renderHeader: /*#__PURE__*/React.createElement(_Header.Header, {
      label: label
    })
  }, /*#__PURE__*/React.createElement(Drawer, null, children)));
};

exports.Accordion = Accordion;